module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "learn-more",
    class: {
      onMobile: _vm.onMobile
    }
  }, [(!_vm.onMobile) ? _c('content-top-header', {
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "pr-3"
  }, [_c('li', [_c('h2', [_vm._v("Learn More")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
          'active tab-active': _vm.isActiveTab(tab.id)
        },
        ("nav-" + (tab.id)) ],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [(tab.icon) ? _c('img', {
      staticClass: "li-icon",
      attrs: {
        "src": tab.icon,
        "width": "18"
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(tab.title) + "\n            ")])])
  })], 2)])], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.activeTab === 'listener') ? _c('div', {
    staticClass: "learn-more-body _listener",
    class: {
      onMobile: _vm.onMobile
    }
  }, [_c('v-container', {
    staticClass: "mt-5 pt-5",
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      '': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    staticClass: "content-space-left",
    attrs: {
      "xs12": "",
      "sm6": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Listen, watch &"), _c('br'), _vm._v(" shop")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  Stream albums, videos & live events. "), _c('br'), _vm._v("\n                  Shop artists & brands, creators keep "), _c('br'), _vm._v("\n                  100%. Build collections, playlists & "), _c('br'), _vm._v("\n                  shopping lists.\n                ")])])]), _vm._v(" "), _c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', {
    staticClass: "fullwidht-right"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/landing-tile1.png'),
      "width": "100%"
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      'flex-wrap-reverse': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm5'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', {
    staticClass: "single-tile-3 fullwidht-left"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/landing-tile2.png'),
      "width": "90%"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "content-space-right pattern-bg-right",
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Organic music "), _c('br'), _vm._v(" discovery")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  YouSound’s algorithm is chronological "), _c('br'), _vm._v("\n                  allowing everything to be discovered. "), _c('br'), _vm._v("\n                  Each creator is verified to ensure high "), _c('br'), _vm._v("\n                  quality content & less saturation.\n                ")])])])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      '': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context text-left"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Streaming payouts"), _c('br'), _vm._v(" reinvented")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  Subscribers share up to 50% of their "), _c('br'), _vm._v("\n                  payment to the top 10 creators they stream "), _c('br'), _vm._v("\n                  each month & can see exactly where their "), _c('br'), _vm._v("\n                  money goes.\n                ")])])]), _vm._v(" "), _c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require('@/assets/landing-tile3-min.png'),
      "width": "100%"
    }
  })])])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      'flex-wrap-reverse': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm5'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', {
    staticClass: "single-tile-3"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/landing-tile4-min.png'),
      "width": "90%"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pattern-bg-right",
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Join & build "), _c('br'), _vm._v(" memberships")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  Support your favorite creators by joining "), _c('br'), _vm._v("\n                  their memberships & gaining access to "), _c('br'), _vm._v("\n                  exclusive content & discussion forums.\n                ")])])])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    class: {
      '': _vm.onMobile
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": "",
      "my-6": "",
      "layer-layout": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "context-layer": ""
    }
  }, [_c('div', {
    staticClass: "tile-context"
  }, [_c('h1', {
    staticClass: "_title"
  }, [_vm._v("Share "), _c('br'), _vm._v(" & get paid")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("\n                  Earn $2/month for a year from each "), _c('br'), _vm._v("\n                  person that subscribes through your "), _c('br'), _vm._v("\n                  shared albums, videos, products & "), _c('br'), _vm._v("\n                  playlists.\n                ")])])]), _vm._v(" "), _c('v-flex', {
    class: [_vm.pageMode ? 'sm6' : 'sm6'],
    attrs: {
      "xs12": "",
      "tiles-layer": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require('@/assets/landing-share-paid.png'),
      "width": "100%"
    }
  })])])], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), (!_vm.hideFooter) ? _c('hr', {
    staticClass: "light mt-5 mb-3"
  }) : _vm._e(), _vm._v(" "), (!_vm.hideFooter) ? _c('div', {
    staticClass: "learn-more-footer"
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("\n        Join the community.\n        "), _c('br'), _vm._v("\n        Download the app.\n      ")]), _vm._v(" "), (_vm.onMobile) ? _c('app-footer', {
    attrs: {
      "hideDownload": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c878984","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/learnMore.vue
// module id = 1688
// module chunks = 180